import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectedProject } from '../../redux/projects/actions';
import { getSelectedSite, selectSite } from '../../redux/site/actions';
import InfinityLoader from '../dropdownSearch/infinityLoader';
import API from '../../services/api';
import utils from '../../utils';

const SiteSelector = ({ customLabel = 'Site', outline = false, onSelection, customSelected, availableSites }) => {
  const [currentSites, setCurrentSites] = useState([]);
  const [totalSites, setTotalSites] = useState(0);
  const [currentFilter, setCurrentFilter] = useState('');

  const project = useSelector(getSelectedProject);
  const selectedSite = useSelector(getSelectedSite);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Array.isArray(availableSites)) {
      const fetchedSites = availableSites.map(site => ({
        label: `${site?.displayName} - ${site?.id}`,
        value: site?.id,
        ...site
      }));
      setCurrentSites(fetchedSites);
      setTotalSites(fetchedSites.length);
    } else if (project) {
      onLoadSites();
    }
  }, [project, availableSites]);

  const handleSiteSelector = siteId => {
    const availableSite = Array.isArray(availableSites) && availableSites.find(site => site.id === siteId);
    if (availableSite) {
      onSelection?.(availableSite);
      return;
    }

    API.getSite(project.id, siteId)
      .then(site => {
        if (onSelection) {
          onSelection(site);
        } else {
          dispatch(selectSite(site));
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const onLoadSites = (nextPageToken, searchingBy = '') => {
    if (Array.isArray(availableSites)) {
      const search = searchingBy.toLowerCase();
      const filteredSites = availableSites
        .filter(site => !search || site.displayName?.toLowerCase().includes(search) || site.id?.toLowerCase().includes(search))
        .map(site => ({ label: `${site?.displayName} - ${site?.id}`, value: site?.id, ...site }));
      setCurrentSites(filteredSites);
      setTotalSites(filteredSites.length);
      return Promise.resolve('');
    }

    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    const filter = searchingBy !== '' ? query : '';

    if (filter !== currentFilter) {
      setCurrentSites([]);
    }

    return API.getSites(project.id, nextPageToken, filter, 'displayName, id', 40).then(res => {
      setTotalSites(res.totalSize);
      const fetchedSites = res.sites.map(site => ({
        label: `${site?.displayName} - ${site?.id}`,
        value: site?.id
      }));

      // Reset list when filter changes
      if (filter !== currentFilter) {
        setCurrentFilter(filter);
        setCurrentSites(fetchedSites);
      } else {
        const newSites = utils.mergeArraysByField(fetchedSites, currentSites, 'value');
        setCurrentSites(newSites);
      }

      return res.nextPageToken;
    });
  };

  if (project) {
    return (
      <div className="site-selector">
        <InfinityLoader
          title={'Search Site'}
          label={customLabel}
          leftAlign
          outline={outline}
          selected={
            customSelected || {
              label: `${selectedSite?.displayName} - ${selectedSite?.id}`,
              value: selectedSite?.id
            }
          }
          onSelect={handleSiteSelector}
          onLoading={onLoadSites}
          totalSize={totalSites}
          options={currentSites}
        />
      </div>
    );
  }

  return null;
};

export default SiteSelector;
